import styled from "styled-components";

const Wrapper = styled.div`
  background: var(--bg-color);
  padding: 80px 0;

  .container {
    @media (max-width: 600px) {
      padding: 0 20px;
    }
    
    h3 {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 60px;
      font-family: 'Playfair Display', serif;
      font-size: 2.5rem;

      @media (max-width: 960px) {
        font-size: 2rem;
      }
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: center;
      gap: 30px;

      @media (max-width: 768px) {
        gap: 20px;
      }

      .item {
        /* Premium Card Style */
        background: white;
        width: 350px;
        min-height: 285px;
        border-radius: var(--radius);
        box-shadow: var(--shadow-sm);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 40px 20px;
        border-top: 4px solid var(--secondary-color); /* Unified Gold Accent */
        transition: var(--transition);

        &:hover {
          transform: translateY(-10px);
          box-shadow: var(--shadow-md);
        }

        .header {
          margin-bottom: 25px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;

          .icon-container {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background-color: rgba(218, 192, 163, 0.2); /* Soft Gold Bg */
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--primary-color);
            transition: var(--transition);
          }

          .icon {
            font-size: 2rem;
          }

          h4 {
            font-size: 1.4rem;
            letter-spacing: 0.5px;
            color: var(--primary-color);
            font-family: 'Playfair Display', serif;
            font-weight: 600;
          }
        }

        /* Hover effect on card moves icon color */
        &:hover .icon-container {
           background-color: var(--primary-color);
           color: var(--secondary-color);
        }

        ul {
          display: flex;
          flex-direction: column;
          gap: 12px;
          
          li {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.05rem;
            color: #555;
            gap: 10px;

            .checked-icon {
              color: var(--secondary-color); /* Gold checkmarks */
              font-size: 18px;
            }
          }
        }
      }
    }
  }
`;

export default Wrapper;
